<template>
    <div>
        <tabbar></tabbar>
        <div class="apply">
            <img src="@/assets/sw3.png" alt="">
        </div>
        <iconlist :list="this.list"></iconlist>
    </div>
</template>

<script>
import tabbar from '../../components/Tabbar'
import iconlist from '../../components/iconlist'
export default {
    components:{
        tabbar,
        iconlist
    },
    data(){
        return{
            list:[]
        }
    },
    mounted(){
        if(!localStorage.getItem('identity')){
            this.list = [
                    {
                        text:'课程资源',
                        son:[
                            {name:'#icontongbukecheng', ming:'同步课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                            {name:'#iconzhishidiankecheng', ming:'知识点课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                            {name:'#iconzhibokecheng', ming:'直播课程',url:'https://www.gankao.com/live/public'},
                            {name:'#iconzhuantikecheng', ming:'专题课程',url:'https://www.rujiaowang.net/mobile/#/CourseDetails'},
                        ],
                    },
                    // {
                    //     text:'学习助手',
                    //     son:[
                    //         {name:'#iconjingdianyuedu', ming:'经典阅读',url:'https://lubo.gankao.com/tag/czkc'},
                    //         {name:'#icongushiwen', ming:'古诗文',url:'https://www.gankao.com/gushiwen'},
                    //     ],
                    // },
                    {
                        text:'素质教育',
                        son:[
                            {name:'#iconpindejiaoyu', ming:'品德教育',url:'http://ykt.eduyun.cn/ykt/rede/index.html'},
                            {name:'#iconshengmingyuanquan', ming:'生命与安全',url:'http://ykt.eduyun.cn/ykt/thematiceaq/index.html'},
                            {name:'#iconxinlianquanjiaoyu', ming:'心理安全教育',url:'http://ykt.eduyun.cn/ykt/yktxljkjy/index.html'},
                            {name:'#iconzhenaishengming', ming:'珍爱生命',url:'http://ykt.eduyun.cn/ykt/yktzasmzt/index.html'},
                            {name:'#iconjiatingjiaoyu', ming:'家庭教育',url:'http://ykt.eduyun.cn/ykt/thematicejt/index.html'},
                            {name:'#iconyanxuejiaoyu', ming:'研学教育',url:'http://ykt.eduyun.cn/ykt/yktyxjd/index.html'},
                            {name:'#iconfangyijiaoyu-copy', ming:'防疫教育',url:'http://ykt.eduyun.cn/ykt/yktkxqdzb/index.html'},
                            {name:'#iconyingshijiaoyu', ming:'影视教育',url:'http://ykt.eduyun.cn/ykt/yktwangxiao/20200221/33857.html'},
                        ],
                    }
                ]
        }  else {
            if(localStorage.getItem('identity') == '教师'){
                this.list = [
                    {
                        text:'课程资源',
                        son:[
                            {name:'#icontongbukecheng', ming:'同步课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                            {name:'#iconzhishidiankecheng', ming:'知识点课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                            {name:'#iconzhibokecheng', ming:'直播课程',url:'https://www.gankao.com/live/public'},
                            {name:'#iconzhuantikecheng', ming:'专题课程',url:'https://www.rujiaowang.net/mobile/#/CourseDetails'},
                            {name:'#iconmianfeike', ming:'免费课',url:'https://lubo.gankao.com/tag/allfree'},
                            {name:'#iconlianjieke', ming:'衔接课',url:'https://lubo.gankao.com/tag/quwei6'},
                            {name:'#icondianzijiaocai', ming:'电子教材',url:'https://www.gankao.com/grade'},
                            {name:'#iconkechengxuexi', ming:'课程学习',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://www.gankao.com/home/mycourse'},
                            {name:'#iconkanzhibo', ming:'看直播',url:'https://www.gankao.com/live/public'},
                            {name:'#iconzuowen', ming:'作文',url:'https://www.gankao.com/zuowen/'+(JSON.parse(localStorage.getItem("grade_id"))==0?'1':JSON.parse(localStorage.getItem("grade_id")))},
                        ],
                    },
                    {
                        text:'学习助手',
                        son:[
                            // {name:'#iconpaizhaosouti-copy', ming:'拍照搜题',
                            //     url:localStorage.getItem("userInfo") == null ?
                            //     'https://www.rujiaowang.net/mobile/#/login':
                            //     'https://image.gankao.com'
                            // },
                            {name:'#iconkehouzuoye', ming:'课后作业',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/zuoye/teacher/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconkeqianyuxi', ming:'课前预习',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/yuxi/teacher/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconkehoufuxi', ming:'课后复习',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/fuxi/teacher/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconAIzhinengpingce-copy', ming:'AI智能评测',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://ai.gankao.com/evaluation'},
                            {name:'#iconjingdianyuedu', ming:'经典阅读',url:'https://lubo.gankao.com/tag/czkc'},
                            {name:'#icongushiwen', ming:'古诗文',url:'https://www.gankao.com/gushiwen'},
                            {name:'#iconjiaoanjiangyi', ming:'教案讲义',url:'https://ziliao.gankao.com/h5?grade=undefined'},
                        ],
                    },
                    {
                        text:'素质教育',
                        son:[
                            {name:'#iconpindejiaoyu', ming:'品德教育',url:'http://ykt.eduyun.cn/ykt/rede/index.html'},
                            {name:'#iconshengmingyuanquan', ming:'生命与安全',url:'http://ykt.eduyun.cn/ykt/thematiceaq/index.html'},
                            {name:'#iconxinlianquanjiaoyu', ming:'心理安全教育',url:'http://ykt.eduyun.cn/ykt/yktxljkjy/index.html'},
                            {name:'#iconzhenaishengming', ming:'珍爱生命',url:'http://ykt.eduyun.cn/ykt/yktzasmzt/index.html'},
                            {name:'#iconjiatingjiaoyu', ming:'家庭教育',url:'http://ykt.eduyun.cn/ykt/thematicejt/index.html'},
                            {name:'#iconyanxuejiaoyu', ming:'研学教育',url:'http://ykt.eduyun.cn/ykt/yktyxjd/index.html'},
                            {name:'#iconfangyijiaoyu-copy', ming:'防疫教育',url:'http://ykt.eduyun.cn/ykt/yktkxqdzb/index.html'},
                            {name:'#iconyingshijiaoyu', ming:'影视教育',url:'http://ykt.eduyun.cn/ykt/yktwangxiao/20200221/33857.html'},
                        ],
                    }
                ]
            } else {
                this.list = [
                    {
                        text:'课程资源',
                        son:[
                            {name:'#icontongbukecheng', ming:'同步课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                            {name:'#iconzhishidiankecheng', ming:'知识点课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                            {name:'#iconzhibokecheng', ming:'直播课程',url:'https://www.gankao.com/live/public'},
                            {name:'#iconzhuantikecheng', ming:'专题课程',url:'https://www.rujiaowang.net/mobile/#/CourseDetails'},
                            {name:'#iconmianfeike', ming:'免费课',url:'https://lubo.gankao.com/tag/allfree'},
                            {name:'#iconlianjieke', ming:'衔接课',url:'https://lubo.gankao.com/tag/quwei6'},
                            {name:'#icondianzijiaocai', ming:'电子教材',url:'https://www.gankao.com/grade'},
                            {name:'#iconkechengxuexi', ming:'课程学习',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://www.gankao.com/home/mycourse'},
                            {name:'#iconkanzhibo', ming:'看直播',url:'https://www.gankao.com/live/public'},
                            {name:'#iconzuowen', ming:'作文',url:'https://www.gankao.com/zuowen/'+(JSON.parse(localStorage.getItem("grade_id"))==0?'1':JSON.parse(localStorage.getItem("grade_id")))},
                        ],
                    },
                    {
                        text:'学习助手',
                        son:[
                            // {name:'#iconpaizhaosouti-copy', ming:'拍照搜题',
                            //     url:localStorage.getItem("userInfo") == null ?
                            //     'https://www.rujiaowang.net/mobile/#/login':
                            //     'https://image.gankao.com'
                            // },
                            {name:'#iconkehouzuoye', ming:'课后作业',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/zuoye/student/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconkeqianyuxi', ming:'课前预习',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/yuxi/student/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconkehoufuxi', ming:'课后复习',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/fuxi/student/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconcuotiben-copy', ming:'错题本',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://tiku.gankao.com/worngquestion_subject'
                            },
                            {name:'#icontikuzhongxin-copy', ming:'学生自测',
                                url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/selftest/index.html#/?token='+
                                JSON.parse(localStorage.getItem("userInfo")).token+
                                '&trace='+localStorage.getItem('trace')+
                                '&apptrace='+localStorage.getItem('apptrace')+
                                '&product_name=孺教网手机端&identity='+
                                localStorage.getItem('identity')
                            },
                            {name:'#iconAIzhinengpingce-copy', ming:'AI智能评测',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://ai.gankao.com/evaluation'},
                            {name:'#iconjingdianyuedu', ming:'经典阅读',url:'https://lubo.gankao.com/tag/czkc'},
                            {name:'#icongushiwen', ming:'古诗文',url:'https://www.gankao.com/gushiwen'},
                            {name:'#iconzhenticeyan', ming:'真题测试', url:localStorage.getItem("userInfo") == null ?
                                'https://www.rujiaowang.net/mobile/#/login':
                                'http://www.rujiaowang.net/app/selftest/index.html#/?token='+(JSON.parse(localStorage.getItem("userInfo")).token)
                            },
                        ],
                    },
                    {
                        text:'素质教育',
                        son:[
                            {name:'#iconpindejiaoyu', ming:'品德教育',url:'http://ykt.eduyun.cn/ykt/rede/index.html'},
                            {name:'#iconshengmingyuanquan', ming:'生命与安全',url:'http://ykt.eduyun.cn/ykt/thematiceaq/index.html'},
                            {name:'#iconxinlianquanjiaoyu', ming:'心理安全教育',url:'http://ykt.eduyun.cn/ykt/yktxljkjy/index.html'},
                            {name:'#iconzhenaishengming', ming:'珍爱生命',url:'http://ykt.eduyun.cn/ykt/yktzasmzt/index.html'},
                            {name:'#iconjiatingjiaoyu', ming:'家庭教育',url:'http://ykt.eduyun.cn/ykt/thematicejt/index.html'},
                            {name:'#iconyanxuejiaoyu', ming:'研学教育',url:'http://ykt.eduyun.cn/ykt/yktyxjd/index.html'},
                            {name:'#iconfangyijiaoyu-copy', ming:'防疫教育',url:'http://ykt.eduyun.cn/ykt/yktkxqdzb/index.html'},
                            {name:'#iconyingshijiaoyu', ming:'影视教育',url:'http://ykt.eduyun.cn/ykt/yktwangxiao/20200221/33857.html'},
                        ],
                    }
                ]
            }
        }
    },
}
</script>

<style scoped>
.apply{
    padding: 15px 15px 0;
}
.apply img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/apply/apply.vue